document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('localization-form').forEach((localizationForm) => {
    const form = localizationForm.querySelector('form');
    if (!form) return;

    // Country
    const countryInput = localizationForm.querySelector('input[name="country_code"]');
    const countryOptions = localizationForm.querySelectorAll('[data-br-country-option]');

    if (countryInput && countryOptions.length) {
      countryOptions.forEach((option) => {
        option.addEventListener('click', (event) => {
          event.preventDefault();

          const country = option.dataset.value;
          if (!country || country === countryInput.value) return;

          countryInput.value = country;
          form.submit();
        });
      });
    }

    // Language
    const languageInput = localizationForm.querySelector('input[name="locale_code"]');
    const languageOptions = localizationForm.querySelectorAll('[data-br-language-option]');

    if (languageInput && languageOptions.length) {
      languageOptions.forEach((option) => {
        option.addEventListener('click', (event) => {
          event.preventDefault();

          const locale = option.dataset.value;
          if (!locale || locale === languageInput.value) return;

          languageInput.value = locale;
          form.submit();
        });
      });
    }
  });
});